
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	props: {
		label: String,
		fancy: Boolean,
		value: Number
	},
	computed: {
		items():ISelectItem<number>[]{
			return [
				"Januari",
				"Februari",
				"Maart",
				"April",
				"Mei",
				"Juni",
				"Juli",
				"Augustus",
				"September",
				"Oktober",
				"November",
				"December"
			].map((m, i)=>{
				return {
					text: m,
					value: i
				};
			});
		}
	},
	methods: {
		onInput(value:number){
			this.$emit("input", value);
		}
	}
});
